import { useMemo, useState, type FC } from 'react'
import type { IconBaseProps } from 'react-icons'
import {
  MdKeyboardArrowLeft as MdKeyboardArrowLeftRaw,
  MdSearch as MdSearchRaw,
} from 'react-icons/md'
import './CreateOrderPlaylistView.scss'
import SearchInput from '../SearchInput/SearchInput'

/** FIX TS2786 */
const MdKeyboardArrowLeft = MdKeyboardArrowLeftRaw as unknown as FC<IconBaseProps>
const MdSearch = MdSearchRaw as unknown as FC<IconBaseProps>

type ClientsKey = 'male' | 'age18_30' | 'age31_45' | 'age46_60'

type StyleKey =
  | 'pop'
  | 'jazzBlues'
  | 'classical'
  | 'rock'
  | 'hiphopRnb'
  | 'retro'
  | 'clubDeepHouse'
  | 'funkSoul'
  | 'loungeChillout'
  | 'bossaNova'
  | 'latina'
  | 'italian'
  | 'france'
  | 'ukrainian'
  | 'georgian'

function CreateOrderPlaylistView({ onBack }: { onBack: () => void }) {
  const [searchValue, setSearchValue] = useState('')

  const [form, setForm] = useState({
    login: '',
    activity: '',
    address: '',
  })

  const [clients, setClients] = useState<Record<ClientsKey, number>>({
    male: 54,
    age18_30: 54,
    age31_45: 54,
    age46_60: 54,
  })

  // ✅ Styles toggles (как на скрине)
  const stylesList = useMemo<Array<{ key: StyleKey; label: string }>>(
    () => [
      { key: 'pop', label: 'POP' },
      { key: 'jazzBlues', label: 'Jazz/Blues' },
      { key: 'classical', label: 'Classical' },
      { key: 'rock', label: 'Rock' },
      { key: 'hiphopRnb', label: 'Hip-Hop/RnB' },
      { key: 'retro', label: 'Retro' },
      { key: 'clubDeepHouse', label: 'Club/Deep/House' },
      { key: 'funkSoul', label: 'Funk & Soul' },
      { key: 'loungeChillout', label: 'Lounge/Chill Out' },
      { key: 'bossaNova', label: 'Bossa Nova' },
      { key: 'latina', label: 'Latina' },
      { key: 'italian', label: 'Italian' },
      { key: 'france', label: 'France' },
      { key: 'ukrainian', label: 'Ukrainian' },
      { key: 'georgian', label: 'Georgian' },
    ],
    [],
  )

  // по скрину примерно: через один включено
  const [styles, setStyles] = useState<Record<StyleKey, boolean>>({
    pop: true,
    jazzBlues: false,
    classical: true,
    rock: false,
    hiphopRnb: true,
    retro: false,
    clubDeepHouse: true,
    funkSoul: false,
    loungeChillout: true,
    bossaNova: false,
    latina: true,
    italian: false,
    france: true,
    ukrainian: false,
    georgian: true,
  })

  const sliders = useMemo<Array<{ key: ClientsKey; label: string }>>(
    () => [
      { key: 'male', label: '? % OF MALE VISITORS' },
      { key: 'age18_30', label: '? % OF VISITORS AGED 18 TO 30' },
      { key: 'age31_45', label: '? % OF VISITORS AGED 31 TO 45' },
      { key: 'age46_60', label: '? % OF VISITORS AGED 46 TO 60' },
    ],
    [],
  )

  const [ratios, setRatios] = useState({
    vocalInstrumental: 54,
    internationalUkrainian: 54,
  })

  const [trackLinks, setTrackLinks] = useState('')
  const [commentary, setCommentary] = useState('')
  const [consent, setConsent] = useState(false)

  const toggleStyle = (key: StyleKey) => {
    setStyles((p) => ({ ...p, [key]: !p[key] }))
  }

  return (
    <div className="createOrderPage">
      <div className="createOrderInner">
        {/* Desktop search like in screenshot */}
        <SearchInput />

        <div style={{ marginTop: '100px' }} className="createOrderHeader">
          <button
            type="button"
            className="createOrderBackBtn"
            onClick={onBack}
            aria-label="Back"
          >
            <MdKeyboardArrowLeft size={50} />
          </button>

          <div className="createOrderHeaderTitle">Order Playlist</div>
        </div>

        <div className="createOrderSubtitle">Information about your business</div>

        <div className="createOrderForm">
          <div className="createOrderField">
            <div className="createOrderLabel">LOGIN</div>
            <input
              className="createOrderInput"
              placeholder="Login"
              value={form.login}
              onChange={(e) => setForm((p) => ({ ...p, login: e.target.value }))}
            />
          </div>

          <div className="createOrderField">
            <div className="createOrderLabel">ACTIVITY</div>
            <input
              className="createOrderInput"
              placeholder="Activity"
              value={form.activity}
              onChange={(e) => setForm((p) => ({ ...p, activity: e.target.value }))}
            />
          </div>

          <div className="createOrderField">
            <div className="createOrderLabel">ADDRESS</div>
            <input
              className="createOrderInput"
              placeholder="Address"
              value={form.address}
              onChange={(e) => setForm((p) => ({ ...p, address: e.target.value }))}
            />
          </div>
        </div>

        <div className="createOrderClientsTitle">Clients info</div>

        <div className="clientsInfo">
          {sliders.map((s) => {
            const v = clients[s.key]
            return (
              <div key={s.key} className="clientRow">
                <div className="clientRowLabel">{s.label}</div>

                {/* value centered above the slider like on screenshot */}
                <div className="clientRowValue" aria-hidden="true">
                  {v}%
                </div>

                <div className="clientRowMid">
                  <div className="clientSideLabel">Man</div>

                  <input
                    className="clientRange"
                    type="range"
                    min={0}
                    max={100}
                    value={v}
                    onChange={(e) =>
                      setClients((p) => ({ ...p, [s.key]: Number(e.target.value) }))
                    }
                    style={{ ['--p' as any]: `${v}%` }}
                    aria-label={s.label}
                  />

                  <div className="clientSideLabel clientSideLabelRight">Woman</div>
                </div>
              </div>
            )
          })}
        </div>

        {/* ✅ Styles toggles (добавлено снизу) */}
        <div className="stylesBlock">
          <div className="stylesTitle">Styles</div>

          <div className="stylesList">
            {stylesList.map((item) => {
              const isOn = styles[item.key]
              return (
                <div key={item.key} className="styleRow">
                  <div className="styleLabel">{item.label}</div>

                  <button
                    type="button"
                    className={`styleToggle ${isOn ? 'isOn' : ''}`}
                    onClick={() => toggleStyle(item.key)}
                    role="switch"
                    aria-checked={isOn}
                    aria-label={item.label}
                  >
                    <span className="styleToggleThumb" />
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* ===== Extra (как на скрине снизу) ===== */}
      <div className="extraBlock">
        {/* VOKAL-INSTRUMENTAL */}
        <div className="ratioRow">
          <div className="ratioRowLabel">VOKAL-INSTRUMENTAL RATIO</div>

          <div className="ratioRowValue" aria-hidden="true">
            {ratios.vocalInstrumental}%
          </div>

          <div className="ratioRowMid">
            <div className="ratioSideLabel">Vokal</div>

            <input
              className="ratioRange"
              type="range"
              min={0}
              max={100}
              value={ratios.vocalInstrumental}
              onChange={(e) =>
                setRatios((p) => ({ ...p, vocalInstrumental: Number(e.target.value) }))
              }
              style={{ ['--p' as any]: `${ratios.vocalInstrumental}%` }}
              aria-label="VOKAL-INSTRUMENTAL RATIO"
            />

            <div className="ratioSideLabel ratioSideLabelRight">Instrumental</div>
          </div>
        </div>

        {/* INTERNATIONAL-UKRAINIAN */}
        <div className="ratioRow">
          <div className="ratioRowLabel">INTERNATIONAL-UKRAINIAN RATIO</div>

          <div className="ratioRowValue" aria-hidden="true">
            {ratios.internationalUkrainian}%
          </div>

          <div className="ratioRowMid">
            <div className="ratioSideLabel">Int&apos;l</div>

            <input
              className="ratioRange"
              type="range"
              min={0}
              max={100}
              value={ratios.internationalUkrainian}
              onChange={(e) =>
                setRatios((p) => ({
                  ...p,
                  internationalUkrainian: Number(e.target.value),
                }))
              }
              style={{ ['--p' as any]: `${ratios.internationalUkrainian}%` }}
              aria-label="INTERNATIONAL-UKRAINIAN RATIO"
            />

            <div className="ratioSideLabel ratioSideLabelRight">UA</div>
          </div>
        </div>

        {/* LINKS INPUT */}
        <div className="extraField">
          <div className="extraFieldLabel">LINKS TO MUSIC TRACK EXAMPLES</div>
          <input
            className="extraFieldInput"
            placeholder="Links to music track examples"
            value={trackLinks}
            onChange={(e) => setTrackLinks(e.target.value)}
          />
        </div>

        {/* COMMENTARY */}
        <div className="commentaryBlock">
          <div className="commentaryTitle">Commentary</div>

          <textarea
            className="commentaryTextarea"
            placeholder="Write your comment here"
            value={commentary}
            onChange={(e) => setCommentary(e.target.value)}
          />
        </div>

        {/* CONSENT */}
        <label className="consentRow">
          <input
            className="consentCheckbox"
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
          />
          <span className="consentText">Даю згоду на обробку персональних даних.</span>
        </label>

        {/* ORDER BUTTON */}
        <button type="button" className="orderBtn" disabled={!consent}>
          Order
        </button>
      </div>
    </div>
  )
}

export default CreateOrderPlaylistView
